import {
  FileResponse,
  IImageManagementTaskDTO,
  ImageManagementResultDTO,
  ImageManagementTaskClient,
  ImageManagementTaskDTO,
  SaveImageTaskDTO,
} from 'business/models/Models';
import BaseService from './BaseService';
import ModelFactory from 'business/models/ModelFactory';
import { getPlainDto } from 'transformers/utils';

export default class ImageManagementTaskService extends BaseService {
  async getAllImageManagementTasks(): Promise<IImageManagementTaskDTO[]> {
    const client: ImageManagementTaskClient = ModelFactory(
      ImageManagementTaskClient,
      false,
      true,
    );
    const data = await client.getAllImageManagementTasks();
    return getPlainDto(data);
  }
  async add(task: ImageManagementTaskDTO): Promise<IImageManagementTaskDTO> {
    const client: ImageManagementTaskClient = ModelFactory(
      ImageManagementTaskClient,
      false,
      true,
    );
    const data = await client.addTask(task);
    return getPlainDto(data);
  }
  async delete(deleteTaskId: number): Promise<boolean> {
    const client: ImageManagementTaskClient = ModelFactory(
      ImageManagementTaskClient,
      false,
      true,
    );
    return await client.deleteTasks(deleteTaskId);
  }
  async save(saveDTO: SaveImageTaskDTO): Promise<IImageManagementTaskDTO[]> {
    const client: ImageManagementTaskClient = ModelFactory(
      ImageManagementTaskClient,
      false,
      true,
    );
    const data = await client.saveImageManagementTask(saveDTO);
    return getPlainDto(data);
  }
  async start(
    startDTO: ImageManagementTaskDTO,
    disableProgress = false,
  ): Promise<ImageManagementResultDTO[]> {
    const client: ImageManagementTaskClient = ModelFactory(
      ImageManagementTaskClient,
      false,
      true,
    );
    const data = await client.startImageManagementTask(startDTO, disableProgress);
    return getPlainDto(data);
  }
  async stop(taskId: number): Promise<boolean> {
    const client: ImageManagementTaskClient = ModelFactory(
      ImageManagementTaskClient,
      false,
      true,
    );
    return await client.stopImageManagementTask(taskId);
  }

  async getImageManagementLogsFile(taskId: number): Promise<FileResponse> {
    const client: ImageManagementTaskClient = ModelFactory(
      ImageManagementTaskClient,
      false,
      true,
    );
    return await client.getViewLogsFile(taskId);
  }
}
